import styled from "styled-components";

export const InLine = styled("div")`
  display: flex;
  flex-shrink: 0;
`;

export const DeleteButton = styled("button")`
    font-family: Inter, sans-serif;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    justify-content: center;
    border: 1px solid rgb(45, 52, 54);
    background-color: rgba(255, 255, 255, 0);
    font-size: 14px;
    border-radius: 6px;
    text-decoration: none;
    letter-spacing: 0.2px;
    font-weight: 500;
    text-align: center;
    transition: 0.2s ease-in-out;
    opacity: 1;
    color: rgb(45, 52, 54);
    height: 40px;
    padding: 0px 12px;
    min-width: 0px;

    &:hover {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0px;
  line-height: normal;
`

export const CardsGrid = styled("div") <{ size }>` 
  padding: 10px 0px;
  display: grid;
  gap: 16px;
  grid-template-rows:${({ size }) => (size === "large" ? "250px" : "110px")};
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
`;

export const CardsGridLarge = styled("div")`
  display: grid;
  gap: 16px;
  // grid-auto-rows: 237px;
  // grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
`;

export const SectionTitle = styled("h2")`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: normal;
`;

export const SessionCardSkeleton = styled("div")`
  background-color: #e0e4ea;
  border-radius: 14px;
`;

export const Center = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TextImg = styled("p")`
  font-size: 16px;
  line-height: 19px;
  text-align: center;

  & > span {
    font-style: oblique;
    font-weight: 100;
  }
`;


export const Text = styled.p`
  font-size: 14px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: left;
`;